import { LOAD_STATE } from '../../../../shared/axios';
import { createReducer, INITIAL_STATE } from '../../../../shared/redux';
import {
    updateCompanySignUpDataAPIConfig,
    updateUserProfileSignUpDataAPIConfig,
} from '../../../../shared/api-configs/profile';
import { CompanySignUpData, UserProfileSignUpData } from '../sign-up-data.types';
import { ValidationError } from './update-sign-up-data.types';

export const SIGN_UP_DATA_UPDATE_SUBMITTED = '@auth/SIGN_UP_DATA_UPDATE_SUBMITTED';
export const UPDATE_SIGN_UP_DATA_REJECTED = '@auth/UPDATE_SIGN_UP_DATA_REJECTED';
export const USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_CALLED = '@auth/USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_CALLED';
export const USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED = '@auth/USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED';
export const USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_FAILED = '@auth/USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_FAILED';
export const COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_CALLED = '@auth/COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_CALLED';
export const COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED = '@auth/COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED';
export const COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_FAILED = '@auth/COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_FAILED';
export const ACCEPT_FORM = '@auth/ACCEPT_FORM';

export type State = {
    data: { userProfile: UserProfileSignUpData, team: CompanySignUpData },
    loadState: string,
    error: ValidationError,
}

export const isUpdateSignUpDataLoading = state => state.auth.updateSignUpData.loadState;
export const getUpdateSignUpDataError = state => state.auth.updateSignUpData.error;

export const submitUpdateSignUpData = (
    userProfile: UserProfileSignUpData,
    team: CompanySignUpData,
) => ({
    type: SIGN_UP_DATA_UPDATE_SUBMITTED,
    payload: { userProfile, team },
});

export const rejectUpdateSignUpData = (error: ValidationError) => ({
    type: UPDATE_SIGN_UP_DATA_REJECTED,
    payload: error,
});

export const requestUserProfileSignUpDataUpdate = (userProfile: UserProfileSignUpData) => ({
    type: USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_CALLED,
    actionTypes: {
        success: USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED,
        fail: USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_FAILED,
    },
    config: updateUserProfileSignUpDataAPIConfig(userProfile),
});

export const requestCompanySignUpDataUpdate = (company: CompanySignUpData) => ({
    type: COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_CALLED,
    actionTypes: {
        success: COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED,
        fail: COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_FAILED,
    },
    config: updateCompanySignUpDataAPIConfig(company),
});

export const acceptForm = () => ({
    type: ACCEPT_FORM,
    payload: {},
});

export const initialState: State = {
    data: { userProfile: null, team: null },
    loadState: LOAD_STATE.SUCCESS,
    error: null,
};

export const updateSignUpDataReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SIGN_UP_DATA_UPDATE_SUBMITTED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: action.payload,
        error: null,
    }),
    [UPDATE_SIGN_UP_DATA_REJECTED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.CANCELED,
        error: { ...state.error, ...action.payload },
    }),
    [USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: action.payload.data,
        loadState: LOAD_STATE.SUCCESS,
    }),
    [USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: null,
    }),
    [COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: action.payload.data,
        loadState: LOAD_STATE.SUCCESS,
    }),
    [COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
});
